import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["purchaseMotion", "apiName", "trackingSource", "screen", "use", "sourceId", "skipInterstitialPage"];
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import CodeSplitEnvWrapper from '../../../components/common/env/CodeSplitEnvWrapper';
import { useAppSelector } from '../../../reducers';
import { productsFromProductInventoryQuantitySelector } from '../../../selectors/ProductInventorySelectors';
import { currentSkuIdForProductSelector } from '../../../selectors/ProductsSelectors';
import { useQueryParamTerm } from '../../../utils/urls/appQueryParamUtilsLegacy';
import { APP } from '../../../v2/constants/tracking/TrackingSources';
import LoadingCTA from './LoadingCTA';
import { jsx as _jsx } from "react/jsx-runtime";
const SingleProductCTA = _ref => {
  let {
      purchaseMotion,
      apiName,
      trackingSource,
      screen,
      use = 'primary',
      sourceId = trackingSource,
      skipInterstitialPage = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const skuId = useAppSelector(state => {
    return currentSkuIdForProductSelector(state, {
      apiName
    });
  });
  const ownedQuantity = useAppSelector(state => {
    if (!skuId) return 0;
    return productsFromProductInventoryQuantitySelector(state, {
      skuId
    });
  });

  // if we go to checkout directly, just add 1 to the owned quantity
  // otherwise interstitial expects the quantity params of what you own in the url
  const quantityToPurchase = skipInterstitialPage ? ownedQuantity + 1 :
  // if we dont own any of the product, default quantity to 1
  ownedQuantity || 1;
  const productConfigurations = skuId ? [createProductConfig({
    skuId,
    quantity: quantityToPurchase
  })] : [];
  const {
    queryParamTerm
  } = useQueryParamTerm();
  if (!skuId) {
    return null;
  }
  const trackingData = {
    app: APP,
    screen,
    uniqueId: `${trackingSource}-${apiName}`
  };
  const sharedProps = Object.assign({
    productConfigurations,
    queryParamTerm,
    trackingSource,
    purchaseMotion,
    use
  }, rest);
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/common/purchaseMotions/PurchaseMotionButtonWrapper`),
    publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/features/purchaseMotions/components/PublicPurchaseMotionButton`),
    authedComponentProps: Object.assign({}, sharedProps, {
      apiName,
      trackingData,
      trackingSource,
      skipInterstitialPage
    }),
    publicComponentProps: Object.assign({}, sharedProps, {
      dtbSource: `pricing-page|${trackingSource}`,
      sourceId,
      nonMerchandiseIdProduct: apiName
    }),
    authedComponentLoadingState: LoadingCTA,
    publicComponentLoadingState: LoadingCTA
  });
};
export default SingleProductCTA;